import { useEffect } from "react";
import { useLocation } from "react-router";
import VerifyHero from "../components/simverify/VerifyHero";
import VerifyRail from "../components/simverify/VerifyRail";
import VerifyStory from "../components/simverify/VerifyStory";
import VerifyEngines from "../components/simverify/VerifyEngines";
import VerifySystem from "../components/simverify/VerifySystem";
import VerifyClose from "../components/simverify/VerifyClose";

function SimVerifyPage() {
  const { hash } = useLocation();

  useEffect(() => {
    const id = hash.replace("#", "");
    if (!id) {
      window.scrollTo(0, 0);
      return undefined;
    }

    const timer = window.setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 160);

    return () => window.clearTimeout(timer);
  }, [hash]);

  return (
    <>
      <VerifyHero />
      <VerifyRail />
      <VerifyStory />
      <VerifyEngines />
      <VerifySystem />
      <VerifyClose />
    </>
  );
}

export default SimVerifyPage;
